/**
 * Copy this Args and interface to contract module
 */
import type { IAction } from '../../action/IAction'
import type { Project } from '../Project'
import { ActionArgs } from '../../action/ActionArgs'
import { Field, ID, InputType } from 'type-graphql'

@InputType()
export class MoveProjectTasksArgs extends ActionArgs {
  @Field(() => ID)
  targetProjectId: string

  @Field(() => [ID])
  taskIds: string[]
}

export interface IMoveProjectTasks extends IAction<Project, MoveProjectTasksArgs> {}
